import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Company Search API Call
 * @param {Object} searchData - { name }
 * @returns {Promise<Object>} - Response data from the API
 */
export const companySearch = async (searchData) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.COMPANY_SEARCH, searchData);
    
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
}; 